var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "350.000000pt",
    height: "55.000000pt",
    viewBox: "130 145 350 55",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,338.000000) scale(0.100000,-0.100000)",
    fill: "#b6b6b6",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2310 1684 l0 -175 23 3 c22 3 22 5 25 176 l2 172 -25 0 -25 0 0 -176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2650 1684 l0 -175 23 3 c22 3 22 5 25 176 l2 172 -25 0 -25 0 0 -176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3640 1685 c0 -167 1 -175 20 -175 17 0 20 8 22 92 3 87 5 93 27 105 48 23 61 3 61 -97 0 -90 5 -105 34 -94 26 10 23 187 -4 214 -24 24 -51 25 -90 5 l-30 -16 0 71 c0 63 -2 70 -20 70 -19 0 -20 -7 -20 -175z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314 1693 c-5 -87 -8 -162 -9 -168 0 -5 7 -10 15 -10 16 0 15 -2 18 153 1 57 6 101 11 98 5 -3 33 -60 62 -126 29 -67 56 -123 59 -125 4 -3 31 50 59 118 28 67 56 129 61 137 12 18 11 27 19 -135 l6 -120 29 -3 28 -4 -6 114 c-13 219 -14 228 -45 228 -24 0 -30 -9 -75 -115 -27 -64 -52 -118 -56 -120 -4 -3 -32 49 -61 115 -49 109 -56 120 -80 120 l-27 0 -8 -157z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880 1680 l0 -169 76 4 c44 2 90 11 112 22 66 32 70 108 6 141 l-35 18 26 14 c14 7 28 24 31 36 18 71 -28 104 -143 104 l-73 0 0 -170z m134 138 c68 -30 33 -117 -46 -118 l-38 0 0 59 c0 70 24 87 84 59z m20 -159 c57 -45 19 -119 -61 -119 l-43 0 0 70 0 70 39 0 c24 0 48 -8 65 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2900 1680 l0 -170 25 0 c25 0 25 1 25 85 l0 85 75 0 75 0 0 -85 c0 -84 0 -85 25 -85 l25 0 0 170 0 170 -25 0 c-24 0 -25 -2 -25 -75 l0 -75 -75 0 -75 0 0 75 c0 73 -1 75 -25 75 l-25 0 0 -170z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2194 1826 c-8 -21 3 -36 27 -36 15 0 20 6 17 22 -4 27 -35 37 -44 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4273 1824 c-10 -26 26 -49 45 -30 8 8 12 22 9 30 -8 21 -46 21 -54 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2194 1737 c-2 -7 -3 -60 -2 -118 3 -96 4 -104 23 -104 19 0 20 8 23 118 3 112 2 117 -18 117 -11 0 -23 -6 -26 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2432 1737 c-29 -16 -18 -28 19 -20 56 11 81 -3 77 -44 -3 -34 -6 -38 -42 -45 -50 -11 -76 -34 -76 -68 0 -50 46 -65 101 -33 27 16 29 16 49 -2 24 -21 52 -7 33 17 -6 7 -13 51 -15 96 -3 69 -7 86 -23 98 -23 17 -92 18 -123 1z m98 -147 c0 -40 -44 -65 -65 -36 -17 22 -11 40 18 54 37 18 47 14 47 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3243 1740 c-39 -16 -25 -28 30 -26 l52 1 0 -40 c0 -38 -2 -39 -39 -47 -54 -11 -78 -35 -74 -72 4 -43 44 -56 94 -32 34 16 38 16 55 0 21 -19 44 -9 33 15 -4 9 -10 54 -14 100 -8 107 -48 136 -137 101z m90 -132 c12 -34 -35 -81 -63 -63 -22 13 -11 53 18 63 37 14 39 14 45 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3444 1725 c-25 -38 -9 -73 46 -105 76 -44 54 -104 -29 -80 -23 6 -31 5 -31 -5 0 -33 102 -34 135 0 40 39 26 76 -45 116 -71 40 -59 95 14 65 37 -15 37 -15 34 7 -5 36 -100 38 -124 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3880 1740 c-10 -6 -11 -12 -2 -22 6 -8 13 -57 14 -109 3 -86 5 -94 23 -94 18 0 20 8 23 91 l3 92 31 13 c46 19 58 -4 58 -114 0 -85 1 -88 22 -85 20 3 21 8 19 90 -2 83 -1 88 23 103 51 34 65 15 68 -93 3 -89 5 -97 23 -97 25 0 35 161 12 205 -16 31 -67 39 -103 15 -22 -14 -26 -14 -40 0 -20 20 -59 19 -95 -2 -26 -16 -30 -16 -46 0 -12 10 -23 13 -33 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4280 1630 c0 -112 1 -120 19 -120 26 0 26 3 23 130 -3 101 -5 110 -23 110 -18 0 -19 -8 -19 -120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4394 1556 c-10 -26 4 -48 28 -44 17 2 23 10 23 28 0 30 -41 42 -51 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4603 1482 c-98 -2 -123 -5 -123 -17 0 -20 250 -27 258 -7 9 24 -11 27 -135 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4780 1475 c0 -3 2 -5 5 -5 3 0 5 2 5 5 0 3 -2 5 -5 5 -3 0 -5 -2 -5 -5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dc3c74615286fa5995d29fb13718277f.svg";
export { ForwardRef as ReactComponent };